export const FavouritesTab = {
  FAVORITES: 'favorites',
  FAVORITES_OTHER_BROKER: 'favorites-other-broker',
};
